export const handleCommonValidator = (obj,skip) => {
    console.log('skip key ' + skip);
    return Object.keys(obj).filter(k => k !== skip).every(k => obj[k] !== null && obj[k] !== '');
};
  